"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageComponent = void 0;
var tslib_1 = require("tslib");
var services_1 = require("../../../services");
var pdfTheme_1 = require("../pdfTheme");
var ImageComponent = /** @class */ (function () {
    function ImageComponent(imageReference, availableWidth, availableHeight) {
        if (availableHeight === void 0) { availableHeight = pdfTheme_1.pdfTheme.page.height; }
        this.imageReference = imageReference;
        this.availableWidth = availableWidth;
        this.availableHeight = availableHeight;
    }
    ImageComponent.prototype.exportContent = function () {
        if (!this.imageReference.timeStamp) {
            return {
                image: this.imageReference.reference,
                fit: [this.availableWidth, this.availableHeight]
            };
        }
        var dateString = services_1.Services.DateTime.formatDate(this.imageReference.timeStamp.toISOString());
        var fontSize = 14 * this.availableWidth / pdfTheme_1.pdfTheme.page.width;
        var rect = {
            type: 'rect',
            x: 0, y: 0,
            w: this.availableWidth / 4, h: fontSize * 1.5,
            color: pdfTheme_1.pdfTheme.background.default,
            fillOpacity: 0.8
        };
        return {
            /**
             *  because we dont know how the image is going to be scaled
             *  centering is the easiest way to line up the text and its background
             */
            alignment: 'center',
            unbreakable: true,
            stack: tslib_1.__spreadArray([
                {
                    image: this.imageReference.reference,
                    fit: [this.availableWidth, this.availableHeight],
                    alignment: 'center'
                }
            ], (this.imageReference.timeStamp && [
                {
                    relativePosition: {
                        x: 0,
                        y: -fontSize * 1.5
                    },
                    canvas: [
                        rect
                    ]
                },
                {
                    text: dateString,
                    style: ['dateText'],
                    fontSize: fontSize,
                    relativePosition: {
                        x: 0,
                        y: -fontSize * pdfTheme_1.MAGIC_SCALING_NUMBER
                    }
                }
            ]), true)
        };
    };
    ImageComponent.prototype.exportStyles = function () {
        // NOTE: This value will also determine the y position of the table and date text above ^^^
        return {
            dateText: {
                color: pdfTheme_1.pdfTheme.font.color.dark
            }
        };
    };
    return ImageComponent;
}());
exports.ImageComponent = ImageComponent;
//# sourceMappingURL=ImageComponent.js.map